import type { CluePublic } from '@cloudfruit-hunts/shared';

interface TextClueProps {
  clue: CluePublic;
}

export function TextClue({ clue }: TextClueProps) {
  return (
    <div className="py-4">
      <p className="text-lg text-text-dark leading-relaxed whitespace-pre-wrap">
        {clue.contentText}
      </p>
    </div>
  );
}
